<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <el-input
              v-model="userApplyQuery.KeyWord"
              placeholder="请输入关键字"
              clearable
            ></el-input>
          </div>
          <div class="condition_item">
            <el-select v-model="userApplyQuery.Status" placeholder="请选择">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="condition_item">
            <el-button
              type="primary"
              @click="getUserApplyList()"
              icon="el-icon-search"
            >
              查询
            </el-button>
          </div>
        </div>
        <div class="form_bar_btn">
          <el-button
            type="primary"
            size="small"
            @click="getUserApplyList()"
            plain
          >
            刷新
          </el-button>
          <el-button type="primary" @click="openPushApplys()">
            批量推送
          </el-button>
          <el-button type="primary" @click="openRejectApplys()">
            批量驳回
          </el-button>
          <el-button type="primary" @click="alreadyReadUserApplys(true)">
            标为已读
          </el-button>
          <el-button type="primary" @click="alreadyReadUserApplys(false)">
            标为未读
          </el-button>
          <el-button type="primary" @click="exportData()">
            导出Excel
          </el-button>
        </div>
      </div>
      <el-empty description="暂无签到" v-show="userApplyItems.length === 0">
      </el-empty>
      <el-table
        row-key="Id"
        :data="userApplyItems"
        ref="userApplyItemsTable"
        style="width: 100%"
        v-show="userApplyItems.length > 0"
        @selection-change="handleSelectionChange"
        @cell-mouse-leave="leaveCall"
        @cell-click="selectCellChange"
        stripe
      >
        <el-table-column
          type="selection"
          width="45"
          :selectable="checkSelectable"
        >
        </el-table-column>
        <el-table-column width="45" align="center">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              style="font-size: 10px"
              title="标为未读"
              v-if="scope.row.IsAlreadyRead"
              @click="alreadyReadUserApply(scope.row, false)"
            >
              <i class="el-icon-s-opportunity"></i>
            </el-link>
            <el-link
              type="danger"
              :underline="false"
              style="font-size: 10px"
              title="标为已读"
              v-if="!scope.row.IsAlreadyRead"
              @click="alreadyReadUserApply(scope.row, true)"
            >
              <i class="el-icon-s-opportunity"></i>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          :index="userApplyIndexMethod"
          label="序号"
          width="50"
        >
        </el-table-column>
        <el-table-column label="姓名" width="100">
          <template slot-scope="scope">
            <el-link type="primary" @click="openDefault(scope.row)">
              {{ scope.row.UserName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="Phone" label="手机号" width="105">
        </el-table-column>
        <el-table-column prop="UnitName" label="公司单位"> </el-table-column>
        <el-table-column prop="IsAgent" label="是否代人参会" width="95">
          <template slot-scope="scope">
            <span v-if="scope.row.IsAgent">是</span>
            <span v-if="!scope.row.IsAgent">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="ClientName" label="授权人姓名" width="100">
        </el-table-column>
        <el-table-column prop="ClientPhone" label="授权人手机号" width="105">
        </el-table-column>
        <el-table-column label="签到时间" width="130">
          <template slot-scope="scope">
            {{ scope.row.Addtime | dateformat('YYYY.MM.DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column label="签到状态" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.Status === 0">未审核</span>
            <span v-if="scope.row.Status === 1" style="color: #f56c6c">
              未通过
            </span>
            <span v-if="scope.row.Status === 2" style="color: #67c23a">
              通过
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="left">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status === 2"
              @click="openEditUserApply(scope.row)"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status === 2"
              @click="openPushGroupModal(scope.row.Id)"
            >
              推送
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status !== 2"
              @click="openPushGroupModal(scope.row.Id)"
            >
              通过
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status !== 1"
              @click="rejectUserApply(scope.row)"
            >
              驳回
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50, 100, 500]"
        :page-size="userApplyQuery.maxResultCount"
        :layout="pagination_layout"
        :total="userApplyTotalCount"
        v-show="userApplyItems.length > 0"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="签到信息-通过"
      :visible.sync="pushGroupsDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
    >
      <div>
        <div style="padding: 0px 0px 10px 30px">
          将签到人员添加到下列选中的分组
        </div>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          v-if="false"
        >
          全选
        </el-checkbox>
        <el-checkbox-group
          v-model="checkedGroups"
          @change="handleCheckedGroupsChange"
        >
          <el-checkbox
            style="display: block; margin-left: 30px; margin-top: 8px"
            v-for="(userGroupItem, index) in userGroupItems"
            :label="userGroupItem.UserGroupId"
            :key="index"
            :disabled="userGroupItem.Disabled"
          >
            {{ userGroupItem.UserGroupName }}
          </el-checkbox>
        </el-checkbox-group>
        <el-link
          type="primary"
          :underline="false"
          icon="el-icon-circle-plus-outline"
          @click="editUserGroup(null)"
          style="margin: 10px 30px"
        >
          新增组
        </el-link>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="pushGroupsDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="savePushGroups()">
          保存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="签到信息-通过"
      :visible.sync="batchPushGroupsDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
    >
      <div>
        <div style="padding: 0px 0px 10px 30px">
          将签到人员添加到下列选中的分组
        </div>
        <el-checkbox
          :indeterminate="batchIndeterminate"
          v-model="batchCheckAll"
          @change="handleBatchCheckAllChange"
          style="margin-left: 30px"
        >
          全选
        </el-checkbox>
        <el-checkbox-group
          v-model="batchCheckedGroups"
          @change="handleBatchCheckedGroupsChange"
        >
          <el-checkbox
            style="display: block; margin-left: 30px; margin-top: 8px"
            v-for="(userGroupItem, index) in batchUserGroupItems"
            :label="userGroupItem.MeetingUserGroupID"
            :key="index"
          >
            {{ userGroupItem.MeetingUserGroupName }}
          </el-checkbox>
        </el-checkbox-group>
        <el-link
          type="primary"
          :underline="false"
          icon="el-icon-circle-plus-outline"
          @click="editUserGroup(null)"
          style="margin: 10px 30px"
        >
          新增组
        </el-link>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="batchPushGroupsDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="saveBatchPushGroups()">
          保存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="签到信息-驳回"
      :visible.sync="rejectDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
    >
      <div>
        将驳回下面的签到：
        <br />
        <el-table
          :data="rejectUserApplyItems"
          stripe
          style="width: 100%"
          height="250"
          border
        >
          <el-table-column prop="UserName" label="姓名" width="120">
          </el-table-column>
          <el-table-column prop="Phone" label="手机号" width="120">
          </el-table-column>
          <el-table-column prop="UnitName" label="公司单位"> </el-table-column>
          <el-table-column prop="Department" label="部门" width="120">
          </el-table-column>
          <el-table-column prop="Position" label="职务" width="120">
          </el-table-column>
        </el-table>
        <br />
        <el-checkbox v-model="isSendMessage">发送通知短信</el-checkbox>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="rejectDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="submitRejectApplys()">
          驳回
        </el-button>
      </div>
      <el-dialog
        width="300px"
        :visible.sync="pictureRotateVerifyVisible"
        append-to-body
        :close-on-click-modal="false"
        custom-class="pictureRotateVerifgClass"
      >
        <div class="picture_rotate_verify_box">
          <div class="picture_rotate_verify_head">安全验证</div>
          <div class="picture_rotate_verify_desc">拖动滑块，使图片角度为正</div>
          <div class="picture_rotate_verify_picbox">
            <img
              class="vcode_spin_img"
              :src="verifyImageCode"
              :style="vcodeImgStyle"
            />
            <span class="vcode_warning" v-if="isShowVcodeWarning">
              <i class="el-icon-close"></i>
            </span>
            <el-alert title="验证码错误" type="error" v-if="isShowVcodeWarning">
            </el-alert>
          </div>
          <div class="picture_rotate_verify_slider">
            <div
              class="picture_rotate_slider_left"
              :style="sliderLeftStyle"
            ></div>
            <div class="picture_rotate_slider_main">
              <el-slider
                v-model="pictureRotateNum"
                :show-tooltip="false"
                :max="360"
                @input="pictureRotateInput()"
                @change="rejectUserApplys()"
              ></el-slider>
            </div>
            <div class="picture_rotate_slider_right"></div>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="editDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
    >
      <el-form
        :model="voteUserApplyForm"
        :rules="voteUserApplyFormRules"
        ref="voteUserApplyForm"
        class="demo-ruleForm"
        :label-position="is_xs ? 'top' : 'right'"
        label-width="125px"
      >
        <el-form-item label="姓名：" prop="UserName">
          <el-input
            v-model="voteUserApplyForm.UserName"
            placeholder="请输入姓名"
            prefix-icon="el-icon-user-solid"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="Phone">
          <el-input
            v-model="voteUserApplyForm.Phone"
            placeholder="请输入手机号"
            prefix-icon="el-icon-phone"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="公司单位：" prop="UnitName">
          <el-input
            v-model="voteUserApplyForm.UnitName"
            placeholder="请输入公司单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门：" prop="Department">
          <el-input
            v-model="voteUserApplyForm.Department"
            placeholder="请输入部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="职务：" prop="Position">
          <el-input
            v-model="voteUserApplyForm.Position"
            placeholder="请输入职务"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否代人参会：" prop="IsAgent">
          <el-radio-group v-model="voteUserApplyForm.IsAgent" size="small">
            <el-radio-button :label="false">本人</el-radio-button>
            <el-radio-button :label="true">代人参会</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="授权人姓名："
          prop="ClientName"
          v-if="voteUserApplyForm.IsAgent"
        >
          <el-input
            v-model="voteUserApplyForm.ClientName"
            placeholder="请输入授权人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="授权人手机号："
          prop="ClientPhone"
          v-if="voteUserApplyForm.IsAgent"
        >
          <el-input
            v-model="voteUserApplyForm.ClientPhone"
            placeholder="请输入授权人手机号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">
          取消
        </el-button>
        <el-button
          type="primary"
          size="medium"
          @click="editUserApply('voteUserApplyForm')"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="签到信息"
      :visible.sync="defaultDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
    >
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            姓名
          </template>
          {{ voteUserApplyInfo.UserName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            手机号
          </template>
          {{ voteUserApplyInfo.Phone }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 公司单位 </template>
          {{ voteUserApplyInfo.UnitName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 部门 </template>
          {{ voteUserApplyInfo.Department }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 职务 </template>
          {{ voteUserApplyInfo.Position }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 是否代人参会 </template>
          <el-tag size="small" v-if="voteUserApplyInfo.IsAgent">是</el-tag>
          <el-tag size="small" v-if="!voteUserApplyInfo.IsAgent">否</el-tag>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            授权人姓名
          </template>
          {{ voteUserApplyInfo.ClientName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            授权人手机号
          </template>
          {{ voteUserApplyInfo.ClientPhone }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-time"></i>
            签到时间
          </template>
          {{ voteUserApplyInfo.Addtime | dateformat('YYYY.MM.DD HH:mm') }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 签到状态 </template>
          <span v-if="voteUserApplyInfo.Status === 0">未审核</span>
          <span v-if="voteUserApplyInfo.Status === 1" style="color: #f56c6c">
            未通过
          </span>
          <span v-if="voteUserApplyInfo.Status === 2" style="color: #67c23a">
            通过
          </span>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="defaultDialogVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
    <EditUserGroup
      :meetId="meetingId"
      :fatherSubmitDialog="editUserGroupDialog"
      ref="editUserGroup"
    ></EditUserGroup>
  </div>
</template>
<script>
import verificationCodeApi from '../../../api/verificationCode'
import voteUserApi from '../../../api/vote/voteUser'
import userApplyApi from '../../../api/vote/userApply'
import EditUserGroup from '@/components/user/EditUserGroup.vue'
export default {
  components: {
    EditUserGroup
  },
  data () {
    const phoneReg = /^1[0-9]{10}$/
    const validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      meetingId: null,
      userApplyTotalCount: 0,
      userApplyQuery: {
        meetingId: null,
        KeyWord: null,
        Status: null,
        maxResultCount: 10,
        skipCount: 0
      },
      currentPage: 1,
      pagination_layout: 'prev, pager, next',
      userApplyItems: [],
      pushGroupsDialogVisible: false,
      //   pushGroupsForm: {},
      //   pushGroupsFormRules: {}
      checkAll: false,
      checkedGroups: [],
      isIndeterminate: true,
      userGroupItems: [],
      selectUserApplyId: null,
      statusList: [{
        value: null,
        label: '请选择状态（全部）'
      }, {
        value: '0',
        label: '未审批'
      }, {
        value: '1',
        label: '未通过'
      }, {
        value: '2',
        label: '已通过'
      }],
      selectRows: [],
      batchPushGroupsDialogVisible: false,
      batchCheckAll: false,
      batchCheckedGroups: [],
      batchIndeterminate: true,
      batchUserGroupItems: [],
      rejectDialogVisible: false,
      rejectUserApplyItems: [],
      isSendMessage: true,
      editDialogVisible: false,
      voteUserApplyForm: {
        Id: null,
        UserName: null,
        Phone: null,
        UnitName: null,
        Department: null,
        Position: null,
        IsAgent: false,
        ClientName: null,
        ClientPhone: null,
        CompanyID: null,
        MeetingID: null
      },
      voteUserApplyFormRules: {
        UserName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }],
        Phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }],
        UnitName: [
          { min: 1, max: 1000, message: '公司单位名称过长', trigger: 'blur' }],
        Department: [
          { min: 1, max: 1000, message: '部门名称过长', trigger: 'blur' }],
        Position: [
          { min: 1, max: 100, message: '职务信息过长', trigger: 'blur' }],
        ClientName: [
          { required: true, message: '请输入授权人姓名', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }],
        ClientPhone: [
          { required: true, message: '请输入授权人手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }]
      },
      defaultDialogVisible: false,
      voteUserApplyInfo: {},
      pictureRotateVerifyVisible: false,
      pictureRotateNum: 0,
      sliderLeftStyle: {
        backgroundColor: '#e4e7ed'
      },
      vcodeImgStyle: {
        transform: 'rotate(0deg)'
      },
      verifyImageCode: '',
      verifyEncryptCode: '',
      isShowVcodeWarning: false,
      alreadyReadItems: []
    }
  },
  methods: {
    handleCheckAllChange (val) {
      this.checkedGroups = val ? ['上海', '北京', '广州', '深圳'] : []
      this.isIndeterminate = false
    },
    handleCheckedGroupsChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.userGroupItems.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.userGroupItems.length
    },
    handleBatchCheckAllChange (val) {
      const groupIds = []
      this.batchUserGroupItems.forEach(function (groupItem, index) {
        groupIds.push(groupItem.MeetingUserGroupID)
      })
      this.batchCheckedGroups = val ? groupIds : []
      this.batchIndeterminate = false
    },
    handleBatchCheckedGroupsChange (value) {
      const checkedCount = value.length
      this.batchCheckAll = checkedCount === this.batchUserGroupItems.length
      this.batchIndeterminate = checkedCount > 0 && checkedCount < this.batchUserGroupItems.length
    },
    getUserApplyList: function () {
      const _this = this
      _this.openLoading()
      userApplyApi.getUserApplyList(_this.userApplyQuery)
        .then(data => {
          _this.userApplyItems = data.Items
          _this.userApplyTotalCount = data.TotalCount
          _this.$nextTick(function () {
            _this.$refs.userApplyItemsTable.doLayout()
          })
          _this.openLoading().close()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
    },
    userApplyIndexMethod (index) {
      return index + this.userApplyQuery.skipCount + 1
    },
    handleSizeChange (val) {
      this.userApplyQuery.maxResultCount = val
      this.$emit('changePaging', this.userApplyQuery.skipCount, this.userApplyQuery.maxResultCount, this.currentPage)
      this.getUserApplyList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.userApplyQuery.skipCount = (val - 1) * this.userApplyQuery.maxResultCount
      this.$emit('changePaging', this.userApplyQuery.skipCount, this.userApplyQuery.maxResultCount, this.currentPage)
      this.getUserApplyList()
    },
    openPushGroupModal: function (userApplyId) {
      const _this = this
      _this.pushGroupsDialogVisible = true
      _this.selectUserApplyId = userApplyId
      _this.getUserApplyAddPushGroups()
    },
    getUserApplyAddPushGroups: function () {
      const _this = this
      _this.openLoading()
      userApplyApi.getUserApplyAddPushGroups({
        MeetingId: this.$route.params.mid,
        UserApplyId: _this.selectUserApplyId
      }).then(data => {
        _this.userGroupItems = data
        _this.checkedGroups = []
        _this.userGroupItems.forEach(function (selectItem, index) {
          if (selectItem.Checked) {
            _this.checkedGroups.push(selectItem.UserGroupId)
          }
        })
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    savePushGroups: function () {
      const _this = this
      _this.openLoading()
      userApplyApi.userApplyAddPushGroup({
        UserGroupIds: _this.checkedGroups,
        UserApplyId: _this.selectUserApplyId
      }).then(data => {
        _this.getUserApplyList()
        _this.$message({
          showClose: true,
          type: 'success',
          message: '保存成功!',
          customClass: 'custom_message'
        })
        _this.pushGroupsDialogVisible = false
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    rejectUserApply: function (item) {
      const _this = this
      _this.rejectUserApplyItems = []
      _this.rejectUserApplyItems.push(item)
      // _this.isSendMessage = true
      _this.rejectDialogVisible = true
      //   _this.$confirm('确认驳回“' + item.UserName + '”的签到吗？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     customClass: 'custom_message_box'
      //   }).then(() => {
      //     const openLoading = _this.openLoading()
      //     userApplyApi.rejectUserApply({
      //       UserApplyId: item.Id
      //     }).then(data => {
      //       openLoading.close()
      //       _this.getUserApplyList()
      //       _this.$message({
      //         type: 'success',
      //         message: item.UserName + '的签到已驳回！',
      //         customClass: 'custom_message'
      //       })
      //     }).catch(err => {
      //       openLoading.close()
      //       return err
      //     })
      //   }).catch(() => {
      //     _this.$message({
      //       type: 'info',
      //       message: '已取消驳回',
      //       customClass: 'custom_message'
      //     })
      //   })
    },
    handleSelectionChange: function (val) {
      this.selectRows = val
    },
    leaveCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.userApplyItemsTable.toggleRowSelection(row)
      }
    },
    selectRowChange: function (row, column, event) {
      this.$refs.userApplyItemsTable.toggleRowSelection(row)
    },
    selectCellChange: function (row, column, cell, event) {
      //   if (cell.cellIndex !== 10) {
      //     this.$refs.userApplyItemsTable.toggleRowSelection(row)
      //   }
      if (event.target.className !== 'el-link--inner' && event.target.className !== 'el-icon-s-opportunity') {
        this.$refs.userApplyItemsTable.toggleRowSelection(row)
      }
    },
    checkSelectable: function (row) {
      return true
    },
    openPushApplys: function () {
      const _this = this
      if (_this.selectRows.length === 0) {
        _this.$message({
          type: 'warning',
          message: '您没有选择要推送的签到人员！',
          customClass: 'custom_message'
        })
        return
      }
      _this.batchPushGroupsDialogVisible = true
      _this.getVoteUserGroups()
    },
    getVoteUserGroups: function () {
      const _this = this
      _this.openLoading()
      _this.batchCheckedGroups = []
      voteUserApi.getVoteUserGroups({
        MeetingId: this.$route.params.mid,
        MaxResultCount: 10000
      }).then(data => {
        _this.batchUserGroupItems = data.Items
        _this.getDefaultUserGroup()
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getDefaultUserGroup: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteUserApi.getDefaultUserGroup({
        meetingId: _this.$route.params.mid
      }).then(data => {
        if (!data) {
          _this.batchUserGroupItems.unshift({ MeetingUserGroupID: null, MeetingUserGroupName: '默认组', Sort: 0 })
        }
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    saveBatchPushGroups: function () {
      const _this = this
      _this.openLoading()
      const userApplyIds = []
      _this.selectRows.forEach(function (selectRow, index) {
        userApplyIds.push(selectRow.Id)
      })
      userApplyApi.userApplysPushGroups({
        UserGroupIds: _this.batchCheckedGroups,
        UserApplyIds: userApplyIds
      }).then(data => {
        _this.getUserApplyList()
        _this.$message({
          showClose: true,
          type: 'success',
          message: '保存成功!',
          customClass: 'custom_message'
        })
        _this.batchPushGroupsDialogVisible = false
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    openRejectApplys: function () {
      const _this = this
      if (_this.selectRows.length === 0) {
        _this.$message({
          type: 'warning',
          message: '您没有选择要驳回的签到人员！',
          customClass: 'custom_message'
        })
        return
      }
      _this.rejectUserApplyItems = []
      _this.rejectUserApplyItems = _this.selectRows
      // _this.isSendMessage = true
      _this.rejectDialogVisible = true
    },
    submitRejectApplys: function () {
      const _this = this
      if (_this.isSendMessage) {
        _this.pictureRotateNum = 0
        _this.openRejectApplysVerify()
      } else {
        _this.rejectUserApplys()
      }
    },
    openRejectApplysVerify: function () {
      const _this = this
      _this.getImageRotateCode()
      _this.pictureRotateVerifyVisible = true
    },
    pictureRotateInput: function () {
      const _this = this
      if (_this.pictureRotateNum > 0) {
        _this.sliderLeftStyle.backgroundColor = '#409EFF'
      }
      _this.vcodeImgStyle.transform = 'rotate(' + _this.pictureRotateNum + 'deg)'
    },
    getImageRotateCode: function () {
      const _this = this
      const openLoading = _this.openLoading()
      verificationCodeApi.getImageRotateCode().then(data => {
        _this.verifyImageCode = 'data:image/png;base64,' + data.ImageCode
        _this.verifyEncryptCode = data.EncryptCode
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    rejectUserApplys: function () {
      const _this = this
      _this.openLoading()
      const userApplyIds = []
      _this.rejectUserApplyItems.forEach(function (selectRow, index) {
        userApplyIds.push(selectRow.Id)
      })
      userApplyApi.rejectUserApplys({
        IsSendMessage: _this.isSendMessage,
        EncryptCode: _this.verifyEncryptCode,
        RotateNumber: _this.pictureRotateNum,
        UserApplyIds: userApplyIds
      }).then(data => {
        if (data === 0) {
          _this.isShowVcodeWarning = true
          setTimeout(() => {
            _this.getImageRotateCode()
            _this.pictureRotateNum = 0
            _this.isShowVcodeWarning = false
          }, 1000)
        }
        if (data === 1) {
          _this.getUserApplyList()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '驳回成功！',
            customClass: 'custom_message'
          })
          _this.pictureRotateVerifyVisible = false
          _this.rejectDialogVisible = false
        }
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    openEditUserApply: function (item) {
      const _this = this
      _this.editDialogVisible = true
      _this.voteUserApplyForm = JSON.parse(JSON.stringify(item))
    },
    editUserApply: function (formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.openLoading()
          userApplyApi.systemEditUserApply(_this.voteUserApplyForm).then(data => {
            _this.getUserApplyList()
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功！',
              customClass: 'custom_message'
            })
            _this.editDialogVisible = false
            _this.openLoading().close()
          }).catch(err => {
            _this.openLoading().close()
            return err
          })
        } else {
          return false
        }
      })
    },
    openDefault: function (item) {
      const _this = this
      _this.voteUserApplyInfo = item
      _this.defaultDialogVisible = true
    },
    editUserGroup: function (userGroupID) {
      this.$refs.editUserGroup.openEditUserGroup(userGroupID)
    },
    editUserGroupDialog: function () {
      const _this = this
      if (_this.batchPushGroupsDialogVisible) {
        _this.getVoteUserGroups()
      }
      if (_this.pushGroupsDialogVisible) {
        _this.getUserApplyAddPushGroups()
      }
    },
    alreadyReadUserApply: function (row, isAlreadyRead) {
      const _this = this
      _this.alreadyReadItems = []
      _this.alreadyReadItems.push(row)
      _this.submitAlreadyReadUserApplys(isAlreadyRead)
    },
    alreadyReadUserApplys: function (isAlreadyRead) {
      const _this = this
      _this.alreadyReadItems = []
      _this.alreadyReadItems = _this.selectRows
      _this.submitAlreadyReadUserApplys(isAlreadyRead)
    },
    submitAlreadyReadUserApplys: function (isAlreadyRead) {
      const _this = this
      const userApplyIds = []
      _this.alreadyReadItems.forEach(function (selectRow, index) {
        userApplyIds.push(selectRow.Id)
      })
      _this.openLoading()
      userApplyApi.alreadyReadUserApply({
        UserApplyIds: userApplyIds,
        IsAlreadyRead: isAlreadyRead
      }).then(data => {
        _this.getUserApplyList()
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    exportData: function () {
      const _this = this
      const openLoading = _this.openLoading('正在导出…')
      userApplyApi.exportUserApplys({
        MeetingId: _this.meetingId
      }).then(data => {
        if (!data) {
          return
        }
        const fileName = '签到人员'

        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    }
  },
  created () {
    this.meetingId = this.$route.params.mid
    this.userApplyQuery.meetingId = this.$route.params.mid
    this.getUserApplyList()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
.pictureRotateVerifgClass {
  border-radius: 10px;
}
.picture_rotate_verify_box {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.picture_rotate_verify_head {
  font-size: 14px;
  line-height: 14px;
  color: #b8b8b8;
  padding-bottom: 10px;
}
.picture_rotate_verify_desc {
  font-size: 18px;
  line-height: 24px;
  color: #1f1f1f;
}
.picture_rotate_verify_picbox {
  width: 152px;
  height: 152px;
  margin: 28px auto 24px;
  position: relative;
}
.picture_rotate_verify_picbox .vcode_spin_img {
  position: relative;
  z-index: 999;
  width: 100%;
  height: 100%;
  pointer-events: none;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
.picture_rotate_verify_picbox .vcode_warning {
  position: absolute;
  top: 20px;
  left: 35px;
  font-size: 82px;
  color: #fff;
  z-index: 1000;
}
.picture_rotate_verify_slider {
  width: 260px;
  margin: 0 auto;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.picture_rotate_slider_main {
  width: 224px;
  margin: 0 auto;
}
.picture_rotate_slider_left {
  width: 18px;
  height: 36px;
  //   background-color: #e4e7ed;
  border-top-left-radius: 36px;
  border-bottom-left-radius: 36px;
}
.picture_rotate_slider_right {
  width: 18px;
  height: 36px;
  background-color: #e4e7ed;
  border-top-right-radius: 36px;
  border-bottom-right-radius: 36px;
}
.picture_rotate_slider_main .el-slider__runway {
  height: 36px;
  //border-radius: 36px;
  border-radius: 0px;
}
.picture_rotate_slider_main .el-slider__runway .el-slider__bar {
  height: 36px;
  //border-radius: 36px 0px 0px 36px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.picture_rotate_slider_main .el-slider__runway .el-slider__button-wrapper {
  height: 36px;
  width: 36px;
  top: 0px;
}
.picture_rotate_slider_main
  .el-slider__runway
  .el-slider__button-wrapper
  .el-slider__button {
  width: 32px;
  height: 32px;
}
.picture_rotate_slider_main
  .el-slider__runway
  .el-slider__button-wrapper
  .el-slider__button:hover {
  transform: scale(1);
}
</style>
